/**
 * DOM ELEMENTS ACTIONS
 */
export const UI_ACTIONS = {
  CLICK: 'click',
  HOVER: 'hover',
};
